import apiHeader from '@/helpers/apiHeader';

const orderTypeActivityTypeService = {
  list(page, params) {
    return apiHeader.get('order-type-activity-types?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('order-type-activity-types/' + id);
  },
};

export default orderTypeActivityTypeService;
